export default "__VITE_PUBLIC_ASSET__b4651b1a__"